import { _ReactPixi, BitmapText } from '@inlet/react-pixi';
import { IBitmapTextStyle } from 'pixi.js';

import { textStyles } from './textStyles';

export type TextProps = _ReactPixi.IBitmapText & {
  weight: 'normal' | 'semibold';
};

export const getTextStyles = ({
  weight = 'normal',
}: TextProps): Partial<IBitmapTextStyle> => {
  return textStyles[weight];
};

export function Text(props: TextProps): JSX.Element {
  const { text, ...otherProps } = props;
  const style = getTextStyles(props);

  return <BitmapText style={style} text={text} {...otherProps} />;
}
